import { api } from './client';

export interface InvCheckRow {
  mrnId: number;
  mrnNo: string;
  mrnItemId: number;
  itemId: number | null;
  itemName: string;
  reqQty: number;
  currentStock: number;
  available: number;
  shortage: number;
  unit: string;
  reorder: number | null;
  stockStatus: 'In Stock' | 'Low Stock' | 'Shortage' | 'Out of Stock';
  hasPo: boolean;
}

export async function listInventoryCheck(filter: {
  mrnId?: number;
  dept?: string;
} = {}): Promise<InvCheckRow[]> {
  const r = await api.get<InvCheckRow[]>('/inventory-check', { params: filter });
  return r.data;
}
